import React, { forwardRef, PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import { withTheme } from 'styled-components'
import moment from 'moment'

import { ButtonReg } from 'atoms/Buttons'
import { FormSelect } from 'atoms/Inputs'
import { Label } from 'atoms/Texts'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow,
  BaseDatePickerInput,
  Input,
  Error,
  RequiredSign
} from './styles'
import * as _ from 'lodash'

export class OutpitWorkModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
    }
    this.errorsRef = {}
  }

  onSubmit() {
    this.setState({ errors: {} })
    const { valid, errors } = this.isValid()
    if (valid) {
      const { outpitWorkData, fnSubmit } = this.props
      fnSubmit(outpitWorkData)
    } else {
      this.setState({ errors }, () => {
        this.errorsRef[`${Object.keys(errors)[0]}`].focus()
      })
    }
  }

  isValid() {
    const { outpitWorkData } = this.props
    let errors = {}
    const validatingFields = _.pick(outpitWorkData, [
      'companyId',
      'contractorId',
      'shiftId',
      'date',
      'startWorkingTime',
      'endWorkingTime',
      'workTypeName',
      'block',
      'excavator',
      'buldozer',
      'dumpTruck',
      'dumpTruckAmount',
      'ritase',
      'volume',
      'materialType',
      'dumpingDistance',
      'dumpingDestination'

    ])
    Object.keys(validatingFields).forEach((key) => {
      if (!validatingFields[key]) {
        errors[key] = {
          ref: key,
          message: 'field ini tidak boleh kosong',
        }
      }
    })

    return { valid: Object.keys(errors).length < 1, errors }
  }

  render() {
    const { theme, outpitWorkData, isDisabled, fnChange, companiesList, worktypeList } = this.props
    const { errors } = this.state
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      arrowPos: 'calc(100% - 12px)',
      arrowSize: '16px'
    }

    const company = companiesList.find(c => c.id === outpitWorkData.companyId)

    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
      <BaseDatePickerInput onClick={onClick} ref={ref}>
        {value}
      </BaseDatePickerInput>
    ))

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            {outpitWorkData.hasOwnProperty('id') ? 'Edit Data' : 'Add Data'}
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <InputRow>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Company
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select company'}
                  onChangeVal={e => fnChange(+e.target.value, 'companyId')}
                  options={companiesList}
                  value={outpitWorkData.companyId}
                  valField={'id'}
                  dispField={'name'}
                  ref={(ref) => (this.errorsRef['companyId'] = ref)}
                  {...inputConfig}
                />
                {'companyId' in errors && <Error>{errors.companyId.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Contractor
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select contractor'}
                  onChangeVal={e => fnChange(+e.target.value, 'contractorId')}
                  options={company ? company.contractors : []}
                  value={outpitWorkData.contractorId}
                  valField={'id'}
                  dispField={'name'}
                  ref={(ref) => (this.errorsRef['contractorId'] = ref)}
                  {...inputConfig}
                />
                {'contractorId' in errors && <Error>{errors.contractorId.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Shift
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select shift'}
                  onChangeVal={e => fnChange(+e.target.value, 'shiftId')}
                  options={company ? company.companyShifts : []}
                  value={outpitWorkData.shiftId}
                  valField={'id'}
                  dispField={'name'}
                  ref={(ref) => (this.errorsRef['shiftId'] = ref)}
                  {...inputConfig}
                />
                {'shiftId' in errors && <Error>{errors.shiftId.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Date
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    selected={moment(outpitWorkData.date).toDate()}
                    onChange={date => fnChange(moment(date).format('YYYY/MM/DD HH:mm'), 'date')}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                    ref={(ref) => (this.errorsRef['date'] = ref)}
                  />
                </div>
                {'date' in errors && <Error>{errors.date.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Working Time - Start
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    value={outpitWorkData.startWorkingTime}
                    selected={outpitWorkData.startWorkingTime}
                    onChange={startWorkingTime => fnChange(startWorkingTime.getTime(), 'startWorkingTime')}
                    customInput={<DatePickerInput />}
                    showTimeSelect
                    showTimeSelectOnly
                    dateFormat="h:mm aa"
                    timeFormat="h:mm aa"
                    timeIntervals={15}
                    timeCaption="Time"
                    ref={(ref) => (this.errorsRef['startWorkingTime'] = ref)}
                  />
                </div>
                {'startWorkingTime' in errors && <Error>{errors.startWorkingTime.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Working Time - End
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    value={outpitWorkData.endWorkingTime}
                    selected={outpitWorkData.endWorkingTime}
                    onChange={endWorkingTime => fnChange(endWorkingTime.getTime(), 'endWorkingTime')}
                    customInput={<DatePickerInput />}
                    showTimeSelect
                    showTimeSelectOnly
                    dateFormat="h:mm aa"
                    timeFormat="h:mm aa"
                    timeIntervals={15}
                    timeCaption="Time"
                    ref={(ref) => (this.errorsRef['endWorkingTime'] = ref)}
                  />
                </div>
                {'endWorkingTime' in errors && <Error>{errors.endWorkingTime.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Work Type
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select work type'}
                  onChangeVal={e => fnChange(String(e.target.value), 'workTypeName')}
                  options={worktypeList ? worktypeList[0].children : []}
                  value={outpitWorkData.workTypeName}
                  valField={'nameDisplay'}
                  dispField={'nameDisplay'}
                  ref={(ref) => (this.errorsRef['workTypeName'] = ref)}
                  {...inputConfig}
                />
                {'workTypeName' in errors && <Error>{errors.workTypeName.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Block
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  placeholder="Enter block"
                  value={outpitWorkData.block}
                  onChange={e => fnChange(e.target.value, 'block')}
                  ref={(ref) => (this.errorsRef['block'] = ref)}
                />
                {'block' in errors && <Error>{errors.block.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Location Section
                </Label>
                <Input
                  type="text"
                  placeholder="Enter location section"
                  value={outpitWorkData.locationSection}
                  onChange={e => fnChange(e.target.value, 'locationSection')}
                />
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Location Elevation
                </Label>
                <Input
                  type="number"
                  placeholder="Enter location elevation"
                  value={outpitWorkData.locationElevation}
                  onChange={e => fnChange(e.target.value, 'locationElevation')}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Excavator
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="text"
                  placeholder="Enter excavator"
                  value={outpitWorkData.excavator}
                  onChange={e => fnChange(e.target.value, 'excavator')}
                  ref={(ref) => (this.errorsRef['excavator'] = ref)}
                />
                {'excavator' in errors && <Error>{errors.excavator.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Buldozer
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="text"
                  placeholder="Enter buldozer"
                  value={outpitWorkData.buldozer}
                  onChange={e => fnChange(e.target.value, 'buldozer')}
                  ref={(ref) => (this.errorsRef['buldozer'] = ref)}
                />
                {'buldozer' in errors && <Error>{errors.buldozer.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Dump Truck
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="text"
                  placeholder="Enter dump truck name"
                  value={outpitWorkData.dumpTruck}
                  onChange={e => fnChange(e.target.value, 'dumpTruck')}
                  ref={(ref) => (this.errorsRef['dumpTruck'] = ref)}
                />
                {'dumpTruck' in errors && <Error>{errors.dumpTruck.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Dump Truck Amount
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  placeholder="Enter dump truck amount"
                  value={outpitWorkData.dumpTruckAmount}
                  onChange={e => fnChange(e.target.value, 'dumpTruckAmount')}
                  ref={(ref) => (this.errorsRef['dumpTruckAmount'] = ref)}
                />
                {'dumpTruckAmount' in errors && <Error>{errors.dumpTruckAmount.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Ritase
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  placeholder="0"
                  value={outpitWorkData.ritase}
                  onChange={e => fnChange(e.target.value, 'ritase')}
                  ref={(ref) => (this.errorsRef['ritase'] = ref)}
                />
                {'ritase' in errors && <Error>{errors.ritase.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Volume
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  placeholder="0"
                  value={outpitWorkData.volume}
                  onChange={e => fnChange(e.target.value, 'volume')}
                  ref={(ref) => (this.errorsRef['volume'] = ref)}
                />
                {'volume' in errors && <Error>{errors.volume.message}</Error>}
              </div>
            </div>
            <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
              Material Type
              <RequiredSign>&nbsp;*</RequiredSign>
            </Label>
            <Input
              type="text"
              placeholder="Enter material type"
              value={outpitWorkData.materialType}
              onChange={e => fnChange(e.target.value, 'materialType')}
              ref={(ref) => (this.errorsRef['materialType'] = ref)}
            />
            {'materialType' in errors && <Error>{errors.materialType.message}</Error>}
            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Dumping Destination
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="text"
                  placeholder="Enter dumping destination"
                  value={outpitWorkData.dumpingDestination}
                  onChange={e => fnChange(e.target.value, 'dumpingDestination')}
                  ref={(ref) => (this.errorsRef['dumpingDestination'] = ref)}
                />
                {'dumpingDestination' in errors && <Error>{errors.dumpingDestination.message}</Error>}
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Dumping Distance
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  placeholder="Enter dumping distance"
                  value={outpitWorkData.dumpingDistance}
                  onChange={e => fnChange(e.target.value, 'dumpingDistance')}
                  ref={(ref) => (this.errorsRef['dumpingDistance'] = ref)}
                />
                {'dumpingDistance' in errors && <Error>{errors.dumpingDistance.message}</Error>}
              </div>
            </div>
            <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
              Remark
            </Label>
            <Input
              type="text"
              placeholder="Enter remark"
              value={outpitWorkData.remark}
              onChange={e => fnChange(e.target.value, 'remark')}
            />
          </InputRow>
        </LevelRowContainer>

        <ModalFooter>
          <ButtonReg onClick={this.props.fnSwitch} disabled={isDisabled} transparent btnTxt={'Cancel'} />
          <ButtonReg onClick={this.onSubmit.bind(this)} disabled={isDisabled} btnTxt={isDisabled ? 'Submitting...' : 'Submit'} />
        </ModalFooter>
      </MainWrapper>
    )
  }
}

export default withTheme(OutpitWorkModal)
